import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import LibraryPage from "./pages/LibraryPage";
import CreateRattrapagePage from "./pages/CreateRattrapagePage";
import RattrapageDetailPage from "./pages/RattrapageDetailPage";
import PublicPreviewPage from "./pages/PublicPreviewPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AccountPage from "./pages/AccountPage";
import SystemSettingsPage from "./pages/SystemSettingsPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/preview/:token" element={<PublicPreviewPage />} />
            <Route
              path="/dashboard"
              element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
            />
            <Route
              path="/bibliotheque"
              element={<ProtectedRoute><LibraryPage /></ProtectedRoute>}
            />
            <Route
              path="/creer"
              element={<ProtectedRoute><CreateRattrapagePage /></ProtectedRoute>}
            />
            <Route
              path="/rattrapage/:id"
              element={<ProtectedRoute><RattrapageDetailPage /></ProtectedRoute>}
            />
            <Route
              path="/admin/utilisateurs"
              element={<AdminRoute><AdminUsersPage /></AdminRoute>}
            />
            <Route
              path="/mon-compte"
              element={<ProtectedRoute><AccountPage /></ProtectedRoute>}
            />
            <Route
              path="/admin/configuration"
              element={<SuperAdminRoute><SystemSettingsPage /></SuperAdminRoute>}
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
